import React from 'react';
import BaseComponent from '../..//components/BaseComponent';
import TextField from '@material-ui/core/TextField';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  // For Underline Color After Click
  palette: {
    primary: { main: "rgba(255, 255, 255, 1)" },
  },
  // For Underline Hover Color
  overrides: {
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: '1px solid #ffffff!important',
        },
        '&:after': {
          borderBottom: '2px solid #0275d8!important',
        },
      },
      root: { // Name of the rule
        color: 'white', // Some CSS
      },
    }
  }
});
export default class InputField extends BaseComponent {
  constructor() {
    super();
    this.state = {
    };
  }
  /**
   * Get class name
   *
   * @returns {string}
   */
  getClassName() {
    let classNames = ['input-group'];
    if (this.props.fullWidth) {
      classNames.push('fulled');
    }

    return classNames.join(' ');
  }

  /**
   * Handle input change
   *
   * @param e
   */
  handleInputChange(e) {
    this.props.handler.handleInputChange(e);
  }
  getValidationError() {
    let messages = [];

    this.props.handler.getErrors().filter(x => x.field == this.props.name).forEach(
      error => messages.push(error.message)
    )
    if (messages.length == 0 ) {
      return null;
    }
    return <div className="validation-message" key={this.props.name + '-error'}>{messages.join("<br/>")}</div>;
  }

  /**
   * Render input
   *
   * @returns {XML}
   */
  render() {
    let className = this.getClassName();
    let validationError = this.getValidationError();
    return (
      <div className={className}>
        <MuiThemeProvider theme={theme}>
          <TextField
            ref="actualInput"
            autoComplete={this.props.autoComplete}
            label={this.props.label}
            type={this.props.type}
            name={this.props.name}
            inputProps={this.props.inputProps}
            value={this.props.value}
            onChange={this.handleInputChange.bind(this)}
            {...this.props.materialProps} />
        </MuiThemeProvider>
        {validationError}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/script/components/ui/InputField.js